import gdpr_en from "@/assets/texts/gdpr_en.txt";
import saas_agb_en from "@/assets/texts/saas_agb_en.txt";
import saas_services_en from "@/assets/texts/saas_services_en.txt";

export default {
    clickToAddTeam: 'Click to add team',
    missingTeams: 'Missing teams',
    projectInstanceMissingTeam: 'At least one team assigned to the project is missing here',
    editTeams: 'Edit Teams',
    ProjectContent: 'Project Content',
    showDetails: 'Show details',
    selectedProject: 'Selected Project',
    validateAsEmail: 'Only allow valid email addresses',
    vformPublishingDisabled: 'Publishing of projects is only possible with a custom webapp. You can create one in the control center under apps.',
    SharingOnlyWithvForm: 'Sharing is only possible with a vForm',
    withLogin: 'With Login',
    withoutLogin: 'Without Login',
    WhitelistedWebsites: 'Whitelisted Websites',
    changewWhitelisting: 'Change whitelisting',
    ExplanationOfWhiteListing: 'In order to embed this project as an iframe, you need to add the domain from where you want to embed it to the list of allowed domains. This is a security feature to prevent cross-site scripting attacks.',
    goToForm: 'Go to form',
    projectModifications: 'Project Modifications',
    UpdatedAt: 'Updated at',
    GeneratedLink: 'Use specific parameters',
    SetInitialSlide: 'Set initial slide',
    SetInitialStep: 'Set initial step',
    HideLoginWindow: 'Hide login window',
    SetInitialLanguage: 'Set initial language',
    NeedToPublishFirst: 'If you want to use this option, you need to publish your project first.',
    HideLoginWindowDescriptionPublished: 'Please only choose this option if you have the means to login programmatically, otherwise this link will not work for you.',
    PublishedVersion: 'Published Project',
    PublishedVersionDescription: 'The published version is available for all users who have the link to this project.',
    GenerateYourLink: 'Links',
    Details: 'Details',
    play: 'play',
    Play: 'Play',
    currentSlideId: 'Current Slide ID',
    currentSlideIndex: 'Current Slide Index',
    currentStepId: 'Current Step ID',
    licenses: 'Lizenzen',
    appPanel: 'App Panel',
    none: 'None',
    private: 'Private',
    manager: 'Manager',
    admin: 'Administrator',
    viewer: 'Viewer',
    editor: 'Editor',
    Team: 'Team',
    teams: 'Teams',
    role: 'Role',
    showGraph: 'Show graph',
    noTeamsAssigned: 'No teams assigned',
    noTagsAvailable: 'No tags available',
    noTagsYet: 'There is no tag with this name, do you want to create one?',
    addOrg: 'Add organization',
    addTeam: 'Add team',
    searchTeams: 'Search teams',
    searchOrgs: 'Search organizations',
    downgradeRoleWarning: 'Downgrading your role will remove your access to some features. Are you sure you want to continue?',
    vSTAGELoginScreen: 'vSTAGE Login Screen',
    noOrgs: 'No organizations available',
    noTeams: 'No teams available',
    confirm: 'Confirm',
    userRemoved: 'User removed',
    confirmRemoveFrom: 'Are you sure you want to remove "{name}" from "{itemName}"?',
    userUpdated: 'User updated',
    alwaysShowLabelText: 'Always show label text',
    OpenPopup: 'Open popup',
    Behaviour: 'Behaviour',
    stateSetterText: `The possible states are as follows:<br />
- Active (a): The object is currently active and operational.<br />
- Hidden (h): The object is hidden and not visible to users.<br />
- Processing (p): The object is undergoing processing or updates.<br />
- Inactive (i): The object is inactive and can not be downloaded or used.<br />`,
    reloadStatus: 'Reload status',
    me: 'me',
    Visibility: 'Visibility',
    NoPermissionUpdateAssembly: 'You have no permission to update this assembly',
    positioning: 'Positioning',
    stateSetterHint: '<b>Processing:</b> The item is being processed right now, it will not show up in vSTAGE until it is finished. This happens on the initial import only.<br />' +
        '<b>Hidden:</b> The item will not be selectable in vSTAGE, but it will still show up in presentations where it has been placed.<br />' +
        '<b>Inactive:</b> The item is not selectable in vSTAGE, it will NOT show up in any presentation.<br />' +
        '<b>Active:</b> The item is selectable in vSTAGE and will show up in presentations.',
    itemState: {
        a: 'Active',
        h: 'Hidden (still usable in vSTAGE)',
        p: 'Processing (not usable in vSTAGE)',
        i: 'Inactive (not usable in vSTAGE)',
    },
    currentSfxDataProcess: 'Current 3D data process',
    noProcessRunning: 'Currently there is no process running',
    sfxDataLogHistory: '3D Data Log History',
    abortedConfirm: 'Understood and hide this message now',
    importAbortedMessage: 'The process has been stopped. If you want revert the changes done by this process, you can do this now.',
    'Cleanup after abort': 'The task has been aborted. The system is removing all temporary CAD and 3D data. This can take a few minutes.',
    abortingPipelineTask: 'Aborting Pipeline Task',
    notYetStarted: 'Your process has been added to the pipeline queue and will be started as soon as possible. You can close the window if you want.',
    processingState: 'Processing state',
    abortPipelineTask: 'Abort Pipeline Task',
    abortPipelineTaskConfirm: 'Are you sure you want to abort this task? This action cannot be undone. The task will be stopped, all your CAD files will be removed from the system. You will have to revert any changes this task has made manually.',
    showPrivateTeams: 'Show private teams',
    instanceMapperAlert: 'Attention: if you change the name property of a 3d part, this will be the new identifier to match your meta data or in case of updates with CAD files on how the names are matched. If this is not your intention, use DisplayName instead.',
    instanceMapperHinty: 'On the left you select the field on your 3D part and on the right you select whatever you want to update it with. You can also click together something like col1_col2',
    uploadMetaFile: 'Upload meta file',
    metaDataUpdaterHint: 'If you want to attach meta data to your 3D parts such as part number or size, you can do this here.',
    instanceUpdaterHint: 'If you want to change e.g. the names of your 3D parts, you can do this here.',
    haveToPinFirst: 'Collapsible elements have to be pinned first',
    partLegendHint: 'In order for this block to work you need to open up vSTAGE, mark some 3D parts as part list relevant – this view then will display those parts and you can also use this list for the word export.',
    HideExamples: 'Hide examples',
    ShowExamples: 'Show examples',
    ShowFileExamples: 'Show file examples',
    ShowRegexExamples: 'Show regex examples',
    ExamplePayload: 'Example Payload',
    UpdateMetaDataInfo: `Update meta data for 3D-Elements. This will attach meta sets and set values for the meta fields.`,
    makeCollapsible: 'Make collapsible',
    SetByTemplate: 'Set by template',
    saveContent: 'Save content as well',
    mfaLoginFailed: 'This did not work, please try again.',
    newLogin: 'New login',
    legacyLogin: 'Legacy login',
    default: 'Default',
    rulesBased: 'Rule based',
    isPreSelected: 'Default Selection',
    Suggestion: 'Suggestion',
    FindInstances: 'Find Instances',
    SelectUnselectAll: 'Select / unselect all',
    MultiEditing: 'Multi editing',
    removeFromAllItems: 'Remove from all items',
    useRegexInfo: 'If the original part of an assembly has the name abc_v_5 heisst and the updated has the name abc_v_6, it will need a regex to ignore the _v_5 part after the name to decide whether the abc_v_5 part needs to be updated using abc_v_6.',
    useRegex: 'Use Regex',
    useSmallImages: 'Use smaller images',
    publicWarning: 'Attention: if you publish this, the content of this presentation will be publicly available! You can always unpublish the already published content.',
    back: 'back',
    keepLoggingDisabled: 'Disable logging permanently',
    EditMode: 'Edit Mode',
    TestMode: 'Test Mode',
    LogDisabled: 'Logging Disabled',
    ModeQuestion: 'In which mode would you like to continue?',
    vformMode: {
        production: 'Live',
        test: 'Test'
    },
    askForTestOrLiveMode: 'On page load ask whether user wants to start in test mode (no logging) or live mode (logging)',
    NewLogAttachedSaveIt: 'We attached a new log for you - you have to save the form in order to make this change permanent',
    showInline: 'Show inline',
    noQuestion: 'No question',
    videoFileNotFound: 'Video file not found',
    useComponentLogs: 'Use component logs where available',
    renderGlobalPanels: 'Render global panels',
    logNoAccess: 'You do not have permission to load the attached log',
    logNotFound: 'The log could not be found',
    logIsEmpty: 'The log contains no data',
    PDFReport: 'PDF Report',
    deleteAllSelected: 'Delete selected files',
    selectUnselectAll: '(Un)select all visible items',
    showLogEntries: 'Show past log entries',
    Unknown: 'Default language',
    instanceMapInfo: 'Select here which of your columns will update which field on the instance',
    selectIdentifier: 'Select the item which identifies a part',
    onvHUBInstance: 'Instance on vHUB',
    inFile: 'In file',
    mapData: 'Map data',
    PostProcessingForInstance: 'Select format for data file',
    alwaysStartCollapsed: 'Show collapsed',
    upAxis: 'Up axis',
    OverallComplexity: 'Amount of details, only for asm, prt, sldasm, CATProduct, STEP and jt',
    errorMessages: {
        404: 'We are sorry, this page has not been found.',
        401: 'You do not have permission to access this page.'
    },
    convertToNewVersion: 'Convert to storage version',
    resetStyling: 'Reset styling',
    applyForAllSteps: 'Apply for all steps',
    resetAll: 'Reset All',
    showInstanceViewer: 'Show instance viewer',
    backToFrontPage: 'Back to front page',
    NoSummaryInEditMode: 'No summary in edit mode',
    Summary: 'Summary',
    EditForm: 'Edit',
    Question: 'Question',
    hideBottomBar: 'Hide bottom bar',
    autoFit: 'Auto fit',
    pinToTop: 'Pin to top',
    pinToTopLeft: 'Pin to top left',
    pinToTopRight: 'Pin to top right',
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    pinToBottom: 'Pin to bottom',
    pinToBottomLeft: 'Pin to bottom left',
    pinToBottomRight: 'Pin to bottom right',
    clearPin: 'Clear pin',
    ThemeColor: 'Theme Color',
    Images: 'Images',
    Videos: 'Videos',
    youWantToReplace: 'Item {itemName} already exists. Are you sure you want to replace the selected item?',
    HideBottomBar: 'Hide bottom bar',
    hasBorderRadius: 'Rounded corners',
    noTopPadding: 'Remove space on top',
    LoadAmountOfParts: 'Load number of parts',
    VIEWERS: 'VIEWERS',
    EDITORS: 'EDITORS',
    yourMediaAssets: 'Your media assets',
    MediaAssets: 'Media Assets',
    VMUsage: 'Usage of pipeline (3D imports)',
    numberOfEditors: 'Number of Editors',
    numberOfViewers: 'Number of Viewers',
    Users: 'Users',
    usedInstances: 'Used instances',
    CurrentItems: 'Recent Activities',
    components: 'components',
    yourComponentLimit: 'Your component limit',
    usedComponents: 'Used components',
    ScalingUnits: 'Scaling Units',
    NewestProjects: 'Newest Projects',
    NewestAssemblies: '3D Objects',
    pipelineErrorMsg: 'There was an error processing your request. Please contact us at support@sideeffects.ch',
    GlobalSettings: 'Global Settings',
    applyForAllItems: 'Apply for all items',
    yourDataGetsConverted: 'Your data will be extended with the new target formats, you will receive an email when this process is finished',
    lodLevel: {
        0: 'High quality only (lod 0)',
        1: 'High and medium quality (lod 0 and 1)',
        2: 'High, medium and low quality (lod 0 - 2)',
        3: 'High, medium, low and extra quality (lod 0 - 3)'
    },
    sfx: {},
    showingAllPivotsInDropdown: 'Showing all pivots in dropdown now',
    restoreVersionConfirm: 'Are you sure you want to reset the object to this version?',
    addGlbFiles: 'Add GLB format',
    showPreview: 'Show preview',
    VersionsBackups: 'Versions/Backups',
    LodLevels: 'Number of complexity levels',
    removeTheHull: 'Remove the hull',
    removeAllSmallParts: 'Remove small parts',
    Simplify: 'Simplify',
    MergeParts: 'Merge parts',
    RemoveParts: 'Remove parts',
    Advanced: 'Advanced',
    Corrections: 'Corrections',
    stringSearch: 'Search by name',
    metaSearch: 'Meta search',
    showMetaValues: 'Show meta info',
    showFlat: 'Show filtered only',
    rootNodeFile: 'Root file',
    lod: 'LOD levels',
    outputFormats: 'Output formats',
    files: 'Files',
    Korrekturen: 'Corrections',
    MsGuidesHint: 'Hints for MS Guides:<br /><ul><li>In order to publish to MS Guides, your project needs to contain an object of the type "MS Guides marker" and those 3D items which you wish to publish to MS Guides need to be marked in vSTAGE as such. Make sure you uploaded the latest version of your project before starting the publishing process.</li><li>MS guides only allows a maximum of 8 items or less depending on the complexity of the objects</li><li>To make your presentation on MS Guides perform with ease, upload only those parts you really need</li><li>Not all items are uploadable due to the limitation that MS Guides only allows .glb files and some items might not be available on vHUB in this format</li></ul>',
    VideoSizeHint: 'For videos bigger than 20MB we recommend using a stream service like vimeo or youtube for better loading performance',
    VideoHint: 'You find the video id usually in the url in your browser',
    YourIdHere: 'Your id here',
    VideoId: 'Video Id',
    EmbedCode: 'Embed Code',
    state: 'state',
    startsAt: 'starts at',
    expiresAt: 'expires at',
    DownloadAll: 'Download all',
    embedOnlyIfPublished: 'The embed link will be shown here if the project is published',
    RestartOrGoHome: 'Do you want to create a new session or just go to the first slide',
    GoTofirstslide: 'Go to the first slide',
    resetSession: 'Reset Session',
    theRequestedResourceWasNotFound: 'The requested resource could not be found.',
    SensorDisplay: 'Sensor Display',
    numbers: 'Numbers',
    SelectSensor: 'Select one or multiple sensors',
    webappPackage: 'Webapp type',
    attachNewLog: 'Attach new log',
    disableLoggingForThisSession: 'Disable logging for this session',
    yourCameraIsntWorkingTryThis: 'Use a different camera? Click here to fix it.',
    changeCamera: 'Change camera',
    selectedCamera: 'Selected camera',
    FullScreen: 'Current Screen',
    organizationsAndTeams: 'Organizations and Teams',
    personalData: 'Personal data',
    fitToContent: 'Fit to content',
    alwaysKioskMode: 'Show always in kiosk mode',
    baseProject: 'Base Project',
    goToApp: 'Go to app',
    reloadMessage: 'The content is being reloaded',
    kioskLeaveHint: 'To leave the kiosk mode, open this side panel, press on the title ({title}) for 10s until the controls reappear',
    addExisting: 'Add existing',
    create: 'Create',
    resetColor: 'Reset color',
    pleaseSelectAType: 'Please select a type',
    publishHint: 'The webapp is being published now. You will receive a notification when this process is finished.',
    setBackToDefault: 'Set back to default',
    deleteValue: 'Delete Value',
    setValueToEmpty: 'Set value to empty',
    clearValue: 'Clear Value',
    AdvancedFeatures: 'Advanced Features',
    open: 'Open',
    comingSoon: 'Coming soon',
    embedInLMS: 'Embed in LMS',
    sendAsLink: 'Send as a link',
    sureLeavePresentation: 'Are you sure you want to leave this presentation? All progress will be lost.',
    IdentifierFieldIsRequired: 'Identifier is required',
    addNextButtonForAllSteps: 'Add next button for all steps',
    alignment: 'alignment',
    qrCameraView: 'QR Camera View',
    addBackgroundColor: 'Add background color',
    setKioskMode: 'Enable kiosk mode',
    RefreshForm: 'Refresh form',
    noImageSelected: 'No image selected',
    noVideoSelected: 'No video selected',
    noAudioSelected: 'No audio selected',
    noPdfSelected: 'No pdf selected',
    currentProject: 'Current project',
    leavePresentation: 'Leave presentation',
    vformProjectLinkerHelptext: 'Projects will not appear if they have already a form attached',
    wrongQrCode: 'Wrong QR code',
    hasNextButtonOnEmptySlide: 'Has next button on slide without step',
    heightInPercent: 'Height in percent',
    pleaseChooseAPresentation: 'Choose a presentation',
    formSettings: 'Settings',
    CreateQrCode: 'Create QR code',
    SelectQrCode: 'Select QR code',
    NoneSelected: 'None selected',
    outputFormatsHelp: "For exports to MS Guides/Hololens you need glb files. When you select multiple output formats this can prolong the import process.",
    OutputFormats: "Output Formats",
    assemblyIsLocked: 'This item cannot be edited while a version is being created, restored or deleted.',
    versioningProcessStarted: 'The backup process has been started. You will receive an email when the process is finished.',
    makeAVersionFirst: 'Before you can update your 3d data, it is recommended to make a backup first. You will get an email when this process is finished. This can take up to several hours depending on the size of your 3D object. Updates without backup at your own risk.',
    restoreVersion: 'Restore this version',
    deleteVersion: 'Delete this version',
    previousSelection: 'Previous selection',
    Update3dHint: 'This is a first version of the 3d data update. Make sure the items you want to keep in your CAD or other file have the same name like before or the element and its child components will be deleted.',
    Update3dData: 'Update 3D data',
    teamsNotMatching: 'Be aware that this item is not available for all teams. Missing team: ',
    addLoggingTable: 'create logging table',
    hasNextButton: 'has next button',
    addStep: 'add step',
    emphasized: 'Emphasized',
    showAsTiles: 'show as tiles',
    showAsTile: 'show as tile',
    showAsPercentage: 'use percentage',
    isUserIdentifierHint: 'For the data of this form to be logged there must be exactly one field that identifies the user. Enable the identifier property next to the input field that identifies the user (e.g. user id).',
    isUserIdentifier: 'identifies user',
    validateCorrectness: 'validate correctness',
    isRequired: 'is required',
    projectFilesNotAvailable: 'The project data for this project are not on the server. Please push your local project to the server and then try again.',
    vFormProjectHint: 'A vForm references slides from a project. Therefore it is not recommended to switch or remove the project because the references will be invalid and have to be changed to slides of the new project. One vForm can only be connected to one single project.',
    addTranslation: 'Add translation',
    editFile: 'edit',
    duplicateFile: 'copy',
    createUpdateDefaultJson: 'create/update default json',
    instanceLocalValueUsesGlobalValueFromAsset: "No value set. Will use global value from asset",
    assetGlobalValueUsesDefaultValue: "No value set. Using default value.",
    TileButtons: {
        imgvid: 'Bilder/Videos/Ton',
        webapp: 'Webapp',
        app: 'App',
        node: 'Node',
        material: 'Material',
        filter: 'ExportProfile',
        text: 'Text',
        model: '3D-Element',
        form: 'vForm',
        qrcode: 'QR-Code',
        report: 'Report',
        sensor: 'Sensor',
        feed: 'Feed',
        scenery: 'Scene',
        assembly: '3D-Group',
        link: 'Link',
        media: 'Media',
        helper: 'vHelper'
    },
    LoadStats: 'Load Stats',
    importAssetViaCSV: 'Import assets via CSV',
    importLog: 'Import log',
    gotIt: 'Got it',
    cookieNotification: 'By logging in you accept the use of cookies. The application will not work without the' +
        ' use of cookies.',
    gdpr_link: 'Data protection declaration',
    Accept: 'Accept',
    Deny: 'Deny',
    gdprExplanation: 'By clicking "accept" you accept the data protection declaration above.<br />When you click' +
        ' "deny" you will be logged out automatically.',
    gdprHint: 'To use vHub you need to accept the following data protection declaration:',
    gdpr: gdpr_en,
    saas_agb: saas_agb_en,
    saas_services: saas_services_en,
    RowLifetime: 'Row Lifetime',
    Days: 'Days',
    Hours: 'Hours',
    Minutes: 'Minutes',
    Seconds: 'Seconds',
    usePicker: 'Use picker tool',
    manualEntry: 'Manual entry',
    noFilterData: 'There is no data in this column to be filtered',
    pwdConditions: {
        atLeastOneUppercaseLetter: 'One uppercase letter',
        atLeastOneDigit: 'One digit',
        atLeastOneSpecialCharacter: 'One special character: {characters}',
        atLeastCharacters: 'Length between {min} and {max} characters',
    },
    repeatPassword: 'Repeat password',
    showPassword: 'Show Password',
    selectVM: 'Select Virtual Machine',
    LoadStorageUsage: 'Load storage usage',
    StorageUsage: 'storage usage',
    stopFeed: 'Stop feed',
    startFeed: 'Start feed',
    restartFeed: 'Restart feed',
    getFeedStatus: 'Get feed status',
    uploadvStageProject: 'Upload a project from vStage first in order to link it here',
    noDataYet: 'No data yet?',
    permissions: {
        logs: 'logs',
        organization: 'Organization',
        general: 'General',
        form: 'Form',
        user: 'User',
        metaset: 'MetaSet',
        team: 'Team'
    },
    a: 'active',
    h: 'hidden',
    p: 'processing',
    i: 'inactive',
    m: 'maintenance',
    createNewAssetBundle: 'Create Asset Bundle',
    UseMetaSetValuesForPivots: 'Use the values for pivots set in meta set: sfx.asset.transform (3D Transforms)',
    DefinePivotCorrections: 'Define pivot corrections',
    keepOriginalNamesAlert: 'Caution: when using this option, the resulting file is not usable in vSTAGE',
    keepOriginalNames: 'Maintain original names (Attention: the resulting file is not usable in vSTAGE)',
    centerPivots: 'Center pivots',
    pivotPlacement: 'Pivot placement (rotation point)',
    pivotComment: 'Source is the default state which means that the pivots will be used as present in the file and not be changed',
    isPreview: 'Is the preview',
    setAsPreview: 'Set as preview',
    valueCopiedToClipboard: 'The value got copied to your clipboard',
    New: 'New',
    DefineMerging: 'Define merging groups',
    State: 'State',
    ConnectionWaiting: 'The connection seems to be slow, trying to connect to server.',
    ConnectionError: 'Could not connect to server, trying to reconnect.',
    RemoveMetaSetWarning: 'ATTENTION: if you remove a metaset from an object, all set values set for this object will be deleted as well',
    AttachOrRemoveMetaSet: 'Attach / remove meta sets',
    UpdateProcessStarted: 'The updated process is now in progress. You will receive a notification when it is finished.',
    NoExportProfileAccess: 'Your organization does not seem to have activated this feature yet – contact us for more information',
    WillDeleteAllRows: 'This will delete all rows in this table',
    for: 'for',
    AllowAccess: 'Allow access',
    SelectOrganizations: 'Select organizations',
    UserCreationHint: 'You can only create users for organizations in which you are an administrator.',
    Role: 'Role',
    AddEntry: 'Add entry',
    limitAccess: 'Limit access',
    fullAccessInOrganization: 'Free access for organization members',
    allowTeamAccess: 'Team access',
    isDefault: 'Is default',
    Documentation: 'Documentation',
    SignIn: 'Sign in',
    frontSloganRight: 'Start now.<br />Create your own<br />3D realtime',
    frontSloganLeft: 'Tomorrow\'s<br />3D Digital Twin<br />Cloud Platform. Now.',
    AssemblyProcessing: 'This 3D item is being processed – updates will be possible after the process is finished',
    UpdateSfxData: 'Update 3D-Data',
    XMLUpdateStart: 'Update meta data',
    SpecifyColumns: 'Column selection',
    GetEmailNotification: 'Get notification per email',
    MetaUpdateMode: 'On <b>reset</b> all data of the selected meta set will be removed<br />On <b>overwrite</b> existing values will be overwritten if new values are provided<br />On <b>extend</b> a value will only be set if no value is pre-existing',
    extend: 'extend',
    overwrite: 'overwrite',
    reset: 'reset',
    ChooseMaterialColumnIfOverwrite: 'Choose a material column if you wish to overwrite the default materials',
    ChooseColorColumnIfOverwrite: 'Choose a color column if you wish to overwrite the default colors',
    UploadMetaFile: 'Upload meta file',
    UpdateMetaData: 'Update meta data',
    UpdateHierarchy: 'Update hierarchy info',
    MetaData: 'Meta Data',
    ActiveServices: 'Active Services',
    NameIsDefinitive: 'Attention, the name cannot be changed after saving.',
    downloadAsCsv: 'Download as CSV',
    Type: 'Type',
    type: {
        backup: 'Backup',
        filter: 'filter',
        Version: 'Version',
        ExportProfile: 'Export profile',
        exportProfile: 'export profile',
        MetaSet: 'Meta set',
        MaterialMapper: 'Material Mapper',
        service: 'Service',
        team: 'Team',
        material: 'Material',
        user: 'User',
        scene: 'Scene',
        project: 'Project',
        VirtualMachine: 'Virtual Machine',
        element: 'Element',
        texture: 'Texture',
    },
    willAlsoBeDeleted: 'The following connected items will also be deleted',
    new: 'new',
    finished: 'finished',
    processing: 'processing',
    greatherThan: 'greater than',
    equals: 'equals',
    lessThan: 'less than',
    contains: 'contains',
    FileSize: 'File Size',
    DownloadFbx: 'Download FBX File',
    sourceProjectId: 'Source project id',
    SourceCode: 'Source Code',
    SelectedFile: 'Selected file',
    importSFX: '3D-Data Import Configuration',
    PostProcessingForMeta: 'Format of meta file',
    metaSetName: 'Name of the meta set',
    metaSetMaterialField: "Meta Set Material Field",
    metaSetColorField: "Meta Set Color Field",
    matMapperLoadFromServer: "LOAD FROM SERVER",
    matMapperLoadFromXML: "LOAD FROM XML",
    selectMaterialColumn: "Select Material Column",
    applyMaterialFromMapper: "Apply Material Mapping",
    applyMaterialTaskStarting: "Starting apply material process ...",
    metaDataUpdateTaskStarting: 'Starting meta data update process ...',
    instanceUpdateTaskStarting: 'Starting instance update process ...',
    instanceUpdateTaskStarted: 'Instance update process started. You will receive an email when task is complete.',
    metaDataUpdateTaskStarted: 'Meta data update process started. You will an email when task is complete.',
    applyMaterialTaskStarted: "Apply material process started. Please wait .. You will receive an email when task is complete.",
    materialName: "The client's material name",
    materialRemapWith: "Material on vHUB",
    loadMaterials: "Load Materials",
    saveMaterialMap: "Save Material Map",
    CreateNew: 'Create new',
    AllConnections: 'All Connections',
    Disclaimer: 'Disclaimer',
    ExportedProfiles: 'Exported Files',
    Preview: 'Preview',
    startProcess: 'Start process',
    ExportProfiles: 'Export profiles',
    createNewSFXFromExportProfile: 'Start export',
    DefineProfile: 'Define Profile',
    searchValues: 'Search values',
    chooseType: 'Choose {type}',
    createExportProfile: 'Create export profile',
    axisMultiplier: 'Rotation',
    pivotsField: 'Pivots',
    axisMultiplierDesc: 'If the axis of the model needs to be rotated, set the number in degrees (e.g.: x: 90, y: 180, z:0)',
    metaFilterInstructions: 'For numbers:<br /><ul><li>gt (greather than)</li><li>lt (less than)</li><li>eq (equal)</li></ul>For text:<br /><ul><li>eq (equal)</li><li>like</li></ul><b>Examples:</b> "gt 5" or "like *text*" or "eq text with spaces"',
    inheritedValues: 'Inherited values',
    globalValues: 'Global values',
    localValues: 'Local values',
    importConfig: 'Import configuration',
    identifierColumn: 'ID column',
    chooseModelIdField: 'Please choose the column from your meta file that contains the ID of the component/element in your model',
    filter3DItems: 'Filter 3D-Elements',
    filter3DItemsDescription: 'If you want only import some parts of your CAD data you can set some filters here.',
    metaFileDataSet: 'Dataset for meta data',
    metaFile: 'Meta File',
    File: 'File',
    file: 'file',
    "File(s)": 'File(s)',
    thisCanTakeSeveralSeconds: 'This can take up to {num} seconds. Depending on the filesize and your connection speed it can also take considerably longer.',
    selectedFiles: 'Selected File(s)',
    removeFile: 'Remove File',
    rootFile: 'Root File',
    dataDescriptionFile: 'Metadata file',
    Filter: 'Filter',
    Search: 'Search',
    pleaseChooseRoot: 'Please select the root component. (Uploaded components need to have a single root element).',
    pleaseChooseDataFile: 'Please select the data enrichment file if available. At the moment only XML-Files resulting from a Windchill search result export are supported.',
    Back: 'Back',
    Forward: 'Forward',
    folderStructureForUpload: 'Required folder structure: there should be no folders in the zip, just the files',
    attentionUploadStartsProcess: 'Attention: Upload starts importing-process right away',
    importHierarchy: 'Import hierarchy',
    cadConvert: 'Convert CAD Data',
    loadBefore: 'Load before',
    loadMore: 'Load more',
    jumpTo: 'Jump to',
    initiallyUploaded: 'Uploaded',
    transferringData: 'Transferring data to data center',
    transferComplete: 'Transfer data to data center complete',
    convertingData: 'Converting data',
    deliveringConvertedData: 'Delivering converted data',
    processingFinished: 'Processing finished',
    yourFileIsFinishedProcessing: 'Your data has been processed and is available under "Linked Data"',
    fileProcessingCannotUpload: 'Your file is being processed right now – you will not be able to upload another file until the processing is finished.',
    stepEmailDisclaimer: 'If you want to receive the notifications about the processing to another than your account email, you can enter a different address here.',
    yourFileIsGettingProcessed: 'Your file is being processed now, you will receive an email when the process is finished.',
    stepFileEmail: 'Email',
    stepFile: 'Step file',
    stepFileStatus: 'Step file processing status',
    reUploadFile: 'Upload a different file',
    pleaseWait: 'Please Wait',
    stepFileProcessingDisclaimer: 'When you start the processing, it will take up to 36 hours to process the file depending on the file size and complexity.',
    uploadWaitDisclaimer: 'Please wait – do not close or reload this window until the upload is finished',
    startProcessing: 'Start Processing',
    fileProcessing: 'File Processing',
    Processing: 'Processing',
    removePicture: 'Remove picture',
    changePicture: 'Change picture',
    editPicture: 'Edit picture',
    picture: 'Picture',
    addPicture: 'Add picture',
    helperTextSfxTypes: '<b>vHelper</b><br />\n' +
        'A vHelper is a model which is used as icons or for navigational purposes and so on. Examples are arrows, human figures and so on.\n' +
        '\n' +
        '<br /><br /><b>Model</b><br />\n' +
        'A model is a 3D Model which is used as a single entity like a fire extinguisher that you just want to place in a scene.\n' +
        '\n' +
        '<br /><br /><b>Assembly</b><br />\n' +
        'An assembly is a 3D Model which contains a hierarchy of multiple parts or objects and which will processed in a way that later you will have the ability to link data to certain parts in that hierarchy or show/hide parts of the assembly.',
    app: 'App',
    webapp: 'Webapp',
    chooseMediaType: 'Choose media type',
    nodata: 'There is no data available for this view',
    clearFilter: 'clear filter',
    from: 'from',
    until: 'until',
    searchMode: 'Search Mode',
    standard: 'standard',
    exactMatch: 'exact match',
    similar: 'similar',
    beginsWith: 'begins with',
    doesNotContain: "doesn't contain",
    justWaitAMinute: 'Please wait...',
    ExportAsPDF: 'Export as PDF',
    basicConfiguration: 'Basic Configuration',
    dataPreSelection: 'Data Preselection',
    labelConfigurator: 'Label Configurator',
    additionalConfiguration: 'Additional Configuration',
    chartName: 'Name of the chart',
    chartDescription: 'Chart Description',
    remainingCharacters: 'Remaining characters',
    limitToNCharactersHint: 'The maximal length of the text is {num} characters.',
    maxChars: 'Max {num} chars.',
    maxSelected: 'You can select only {num} item(s).',
    chooseLabelConfiguration: 'Choose the data you want to appear in the tooltip.',
    linkToOriginalTable: 'Go to table',
    instances: 'Local copies',
    addData: 'Add data',
    addrow: 'Add row',
    reloadMappingsWarningLoseChanges: "You will lose all your unsaved work. Continue?",
    url: 'URL',
    billingEmail: 'Billing Email',
    owner: 'Owner',
    visibility: 'Visibility',
    displayName: 'Display Name',
    maintext: 'Main Text',
    editQrcode: 'Edit QR code',
    noAccess: 'You have no permission to access that page',
    noAccessChangeOrg: 'You don\'t have the permission to access that page with the selected organization',
    AccessDenied: 'Access Denied',
    orgVisibilityTypes: {
        '0': 'Private',
        '1': 'Organization Level',
        '2': 'Public',
    },
    teamVisibilityTypes: {
        '0': 'private',
        '1': 'public',
        '2': 'global (new users get added automatically)'
    },
    mediaCategory: {
        '0': 'application',
        '1': 'audio',
        '2': 'font',
        '3': 'image',
        '4': 'message',
        '5': 'model',
        '7': 'pdf',
        '8': 'text',
        '9': 'video',
    },
    fieldname: 'Field Name',
    insertBeforeField: 'Insert before the following field',
    order: 'Order',
    text: 'Text',
    string: 'Text',
    number: 'Number',
    timestamp: 'Timestamp',
    time: 'Time',
    typeToSelect: 'Type to select',
    index: 'Index',
    chooseSfxType: 'Please choose a type',
    chooseAppType: 'Please choose a type',
    choseDataSourceType: 'Please choose a type',
    choseQrcodeType: 'Please choose a type',
    choseFieldType: 'Please choose a type',
    deletePromptQuestion: 'Are you sure you want to delete the selected object?',
    deletePromptQuestionWithParams: 'Are you sure you want to delete "{name}"?',
    unlinkPromptQuestion: 'Are you sure you want to unlink the selected object and lose all local data from that link?',
    yes: 'Yes',
    abort: 'Cancel',
    addqrcode: 'Create QR Code',
    addQrcode: 'Create QR Code',
    username: 'Username',
    password: 'Password',
    user: {
        role: 'Role',
    },
    data: {
        lastUpdate: 'Last update',
        name: 'Name',
        edit: 'Edit',
    },
    Connect: 'Connect',
    edit: 'Edit',
    description: 'Description',
    media: 'media',
    name: 'Name',
    submit: 'Submit',
    Created: 'Created',
    Updated: 'Updated',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    telnr: 'Phone Number',
    withCountryCode: 'With Country Code (e.g. +41)',
    uploadfor: 'Upload for',
    ['Last change']: 'Last change',
    Contributors: 'Contributors',
    helper: 'vHelper',
    model: '3D-Element',
    assembly: '3D-Group',
    SFXData: '3D-Data',
    sfxdata: "3D data",
    qrcodes: "QR codes",
    materialmappers: "Mappers",
    qrcode: "QR Code",
    datasources: 'Datasources',
    showMorePivotPositions: 'Show all pivot positions',
    pivot: {
        source: 'Original',
        top: 'Top',
        left: 'Left',
        right: 'Right',
        center: 'Center',
        base: 'Bottom',
        front: 'Front',
        back: 'Back'
    },
    exportPrompt: {
        generatePartList: 'Generate part list table at the bottom',
        pdfOptions: 'PDF Options',
        export: "Export",
        word: "Word",
        wordOptions: "Word Options",
        pdf: "PDF",
        PDFReport: "PDF Report",
        template: "Template",
        autoGenerateLegend: "Auto Generate Legend",
        metaSet: "Meta Set",
        metaField: "Meta Field",
        download: "Download",
        pleaseSelectAlternativeNames:
            "Please select a metaset and metafield if you want to display alternative part names in the legend",
    },
    events: {
        instanceDeleteFailed: 'The instance could not be deleted',
        instanceDataMetaValuesUpdated: 'Instance value updated',
        addedNextButtons: 'Next buttons have been added',
        instanceUpdated: 'The instance has been updated',
        metaValuesUpdated: 'A meta value has been updated',
        tagUpdated: 'The tag has been updated',
        metaFieldCreated: 'A meta field has been created',
        metaSetCreated: 'A meta set has been created',
        appUpdated: 'The application has been updated.',
        appCreated: 'A new app has been created.',
        appDeleted: 'The app has been deleted.',
        appMetaValuesUpdated: 'The value was updated.',
        dataSetCreated: 'A new data set has been created.',
        dataSetDeleted: 'The data set has been deleted.',
        dataSetUpdated: 'The data set has been updated.',
        dataSourceMetaValuesUpdated: 'The value was updated.',
        dataSourceCreated: 'A new data source has been created.',
        dataSourceDeleted: 'The data source has been deleted.',
        dataSourceUpdated: 'The data source has been updated.',
        datasetMetaValuesUpdated: 'The value was updated.',
        formUpdated: 'The form has been updated.',
        formCreated: 'The form has been created.',
        formDataCleared: 'The form data was cleared.',
        mediaCreated: 'A new media object has been created.',
        mediaDeleted: 'The media object has been deleted.',
        mediaUpdated: 'The media object has been updated.',
        mediaMetaValuesUpdated: 'The value was updated.',
        metaFieldDeleted: 'The MetaField was deleted.',
        metaFieldUpdated: 'The MetaField has been updated.',
        organizationUpdated: 'The organization has been updated',
        organizationCreated: 'The organization has been created.',
        organizationDeleted: 'The organization has been deleted.',
        pictureRemoved: 'The picture has been removed.',
        projectCreated: 'A new project has been created.',
        projectDeleted: 'The project has been deleted.',
        projectUpdated: 'The project has been updated.',
        projectMetaValuesUpdated: 'The value was updated.',
        qrcodeCreated: 'A new qr code has been created.',
        qrcodeDeleted: 'The qr code has been deleted.',
        qrcodeUpdated: 'The qr code has been updated.',
        qrcodeMetaValuesUpdated: 'The value was updated.',
        reportCreated: 'A new report has been created.',
        reportUpdated: 'The report has been updated.',
        reportMetaValuesUpdated: 'The value was updated.',
        sceneCreated: 'A new scene has been created.',
        sceneDeleted: 'The scene has been deleted.',
        sceneUpdated: 'The scene has been updated.',
        sceneMetaValuesUpdated: 'The value was updated.',
        sfxDataCreated: 'A new 3d object has been created.',
        sfxDataDeleted: 'The 3D object has been deleted.',
        sfxDataUpdated: 'The 3D Object has been updated.',
        sfxDataMetaValuesUpdated: 'The value was updated.',
        textUpdated: 'The text was updated.',
        textCreated: 'The text was created.',
        tagDeleted: 'The tag has been deleted.',
        tagsAdded: 'The tag was added',
        tagsRemoved: 'The tag has been removed.',
        tagCreated: 'The tag was created',
        userUpdated: 'The user data have been updated.',
        userCreated: 'A new user has been created',
        metaValuesUnset: 'Meta value deleted from database',
        materialsSaved: 'Materials have been saved',
    },
    enternamehere: 'Name',
    backtooverview: 'back to overview',
    projectloading: 'Project loading',
    CONTRIBUTORS: 'CONTRIBUTORS',
    STATUS: 'STATUS',
    entertitlehere: 'Enter title here',
    createNewType: 'Create new {type}',
    selectedType: 'Selected {type}',
    addNewType: 'Add new {type}',
    deleteType: 'Delete {type}',
    createNewTypeFile: 'create new {type}',
    downloadType: 'Download {type}',
    updateType: 'Update {type}',
    enterdeschere: 'Enter description here',
    createnewapp: 'Create new app',
    createNewApp: 'Create new app',
    createNewProject: 'Create new project',
    createNewSfxdata: 'Import 3D-data',
    updateSfxdata: 'Update 3D-data',
    createNewMedia: 'Create new media',
    createNewUser: 'Create new user',
    createNewMetaField: 'Create new metaField',
    createNewMetaSet: 'Create new metaSet',
    createNewOrganization: 'Create new organization',
    createNewReport: 'Create new report',
    createNewText: 'Create new text',
    createNewQrCode: 'Create QR Code',
    createNewForm: 'Create new form',
    createNewMaterialMapper: 'New material mapper',
    SAVE: 'SAVE',
    REMOVE: 'REMOVE',
    makeCodePretty: 'Pretty Code',
    imageupload: 'Drag file here or click to upload',
    fileupload: 'Drag file here or click to upload',
    Media: "Media",
    Datasets: "Data Sources",
    ChooseProjectForApp: 'Choose a base project for this app',
    deletefield: 'DELETE FIELD',
    Anumberbetween: 'A number between {num} and {num2}',
    duplicateFileError: 'A file with the name {fileName} already exists. Please rename your file or choose another one to upload.',
    addnewfield: 'Add new field',
    addnewcolumn: 'Add new column',
    savefield: 'Save field',
    editfield: 'Edit field "{field}"',
    fieldCannotBeEditedWhenData: 'The field cannot be edited if there is any data filled in the table.',
    NotANumber: 'The entered value is not a number',
    createnew: 'Create new',
    filtering: 'Filtering',
    resources: 'Resources',
    library: "Library",
    addconnection: "Connecting data",
    removeconnection: "Verknüpfung wird entfernt",
    LinkedData: 'Linked Data',
    LocalLinkedItems: 'Linked Data',
    localLinkedItems: 'Linked Data',
    createNewDataSet: 'Create a new table',
    createNewDataSource: 'Create new datasource',
    MetaPanel: 'Meta Information',
    sfxEditFile: '3D File',
    mediaEditFile: 'Media File',
    textEditFile: '.po Translation File',
    localValuesDisclaimer: 'The local values override the global values for this one instance',
    assetMetaDisclaimer: 'Attention: if you edit these values they will change everyhwere where this asset is in use and its values not locally overwritten',
    uploadDisclaimer: 'Attention: if you upload a new file it will be replaced everywhere where it used',
    onlySingleLinkingDisclaimer: 'These items can only linked once – the instances column shows where it is already linked.',
    forms: {
        isDefaultOrganization: 'Is default organization',
        default: 'Is default',
    },
    meta: {
        type: {
            int: 'Integer',
            str: 'String',
            json: 'JSON',
            float: 'Float',
            enum: 'Enumeration',
            bool: 'Boolean',
            clr: 'Color',
            v2: 'Vector 2',
            v3: 'Vector 3',
            v4: 'Vector 4',
            time: 'Time',
            datetime: 'Date and time',
            date: 'Date',
            project: 'Project',
            password: 'Password',
            xform3: 'Xform3',
            xform2: 'Xform2',
            email: 'Email',
            ip: 'IP',
            ipv6: 'Ipv6',
            uri: 'Uri',
            range: 'Range',
            asset: {
                feed: 'Feed',
                sensor: 'Sensor'
            },

        }
    },
    vform: {
        legend: "Legend",
        legendPlaceholder: "Legend placeholder",
        noCaptionsDetected: "No captions detected",
        partLegend: "Partlist Legend",
        titleAlignment: "Title Alignment",
        textAlignment: "Text Alignment",
        partLegendLoading: "Loading Partlist Legend",
        video: 'Video',
        audio: 'Audio',
        sendEmailToAddress: 'Send email to',
        Checkout: 'Checkout',
        HistoryBack: 'History back',
        FirstSlide: 'First slide',
        LastSlide: 'Last slide',
        FirstStep: 'First step',
        LastStep: 'Last step',
        formSummary: 'Form Summary',
        vimeo: 'Vimeo',
        youtube: 'Youtube',
        other: 'Other',
        embed: 'URL Embed',
        directEmbed: 'Direct embed',
        upload: 'Direct Upload',
        chart_line: "Line",
        chart_text: "Text",
        sensor: 'Sensor Data',
        codeSnippet: 'Code',
        translationMessage: "{key} translation for: {content}",
        oldVersionMessage: "You have opened an older vForm, which was automatically converted to the latest vFrom version. Before saving, please check that all elements are correct and no information was lost.",
        steps: "Steps",
        button: "Button",
        login: "Login",
        logout: "Logout",
        editor: "Form Editor",
        checkoutButton: "Checkout Button",
        preview: "Preview",
        headline: "Headline",
        website: "Website",
        singlechoice: "single choice",
        multichoice: "multi choice",
        textfield: "Plain Text",
        shortanswer: "Text Input Field",
        helloworld: "Hello World",
        shortLorem: "Text ...",
        longLorem: "Short Answer ..",
        image: "Image",
        qrcode: "QR Code",
        stepControl: "Step Control",
        projectSwitch: "Project Switch",
        metaListFilter: "Meta List Filter",
        mediaLoader: "Media Loader",
        divider: "Divider",
        verticalSpace: "Vertical Space",
        slide: "Slide",
        UnnamedStep: "Unnamed Step",
        NoAction: "No Action",
        NextSlide: "Next Slide",
        GoToStep: "Go to Step",
        GoToSlide: "Go to Slide",
        newStep: "New Step",
        blocks: "Blocks",
        properties: "Properties",
        stepProperties: "Step",
        cannotSelectStepsFromOldVform: "You will be able to select steps from this project once you convert it to the new vform version.",
        nextStepButtonsAdded: "'Next Button' was successfully added to each step",
        link: "Link",
        iframe: "iFrame",
        newTab: "Open in new tab",
        loseChangesWarning: "You will lose all your changes. Continue?",
        doNotShowDeleteElementConfirmation: "Do not show this again",
        publishButton: "Publish Project",
        publishvformToAppMessage: "Publish started... You will receive an email with the outcome.",
        unpublishvformToAppMessage: "Unpublish started... You will receive an email with the outcome.",
        publishTragetWebAppRequired: "Please select target webapp.",
        selectTragetWebAppPlaceholder: "Select target webapp",
        unpublish: "Unpublish",
        republish: "Republish",
        listOfWebAppsWhereVformIsPublished: "Published in:",
        textArea: "Multi line textfield",
        metaInfo: "Meta Info",
        partInfovStageOnly: "Part Info block is visible only in vStage",
        partInfo: "Part Info",
        selectInstanceFromScene: "You can select an instance to view more details",
        selectInstanceNotFound: "Selected Instance not found / no extra info",
        sureClearingFormData: "Are you sure you want to clear all form data?",
        hotspots: "Hotspots",
        learningDot: "Hotspot",
        possibleAnswers: "Possible answers",
        correct: "Correct",
        learningDots: "Basu-Dots",
        addLearningDot: "Add Label",
        listMatchpanel: "Case 1",
        listMatchimage: "Case 2",
        listMatch: "List Match",
        listMatchTextInput: "List Match - Text Input",
        addHotspot: "Add Hotspot",
        clearFormData: "Clear Form Data",
        hotspot: {
            popup: 'Popup',
            goto: 'Navigate'
        },
        buttonStyle: {
            Text: 'Text',
            Arrow: 'Arrow',
            TextAndArrow: 'Text & Arrow'
        },
        isMasterPanel: 'Is Global',
        localPanels: 'Local Panels',
        globalPanels: 'Global Panels',
        hideBottomBar: 'Hide Bottom Bar',
        autoFit: "Auto Fit",
        collapsible: "Collapsible",
        initiallyCollapsed: "Initial Collapsed",
        showHideSliders: "Show Additional options",
        noPin: "No pin",
        pinTop: "Pin Top",
        pinTopRight: "Pin Top Right",
        pinTopLeft: "Pin Top Left",
        pinLeft: "Pin Left",
        pinRight: "Pin Right",
        pinBottom: "Pin Bottom",
        pinBottomLeft: "Pin Bottom Left",
        pinBottomRight: "Pin Bottom Right",
        autoPlay: "Auto Play",
        loop: "Loop",
        templates: "Templates",
        missingTemplate: "Template missing or deleted. We recommend removing the currently attached template and selecting a new one.",
        removeTemplate: "Remove Template",
        noTemplatesFound: "No matching templates found.",
        viewAllTemplates: "View/modfiy templates",
        close: "Close",
        templatePreviewer: "Template Previewer",
        templateAssetNotFound: "Template asset for your organization not found",
        templateEditor: "Template Editor",
        templateType: "Template Type",
        noTemplateSelected: "No template selected.",
        templateIsEmpty: "Template name cannot be empty.",
        templateOverwrite: "You are about to overwrite an existing template. Everywhere this template is used, the changes will be applied.",
        createNewTemplate: "Create New Template",
        selectTemplate: "Select Template",
        saveTemplate: "Save Template",
        saveChanges: "Save Changes",
        renameTemplate: "Rename Template",
        deleteTemplateQuestion: 'Are you sure you want to delete the template "{templatename}"? It will be deleted for the whole organization.',
    },
    isCorrectAnswer: "Is correct",
    isChecked: "Is checked",
    cclight: {
        notFound: "404 Not found",
        notFoundMessage: "Page not found. Please check the URL or contact the administrator.",
        unauthorized: "401 Unauthorized",
        unauthorizedMessage: "No access - please contact your administrator",
        goBack: "Go back",
    },
    rotLocScaleSetterPrompt: "Please note that this widget now uses the same coordinate system as vSTAGE. Saving this will result in the positioning to be adjusted for all vSTAGE presentations accordingly.",
    linkedDataMessage: "You just linked a sensor to a 3D object. Please remember to restart the feed for the sensor data to be saved when coming in.",
    isMaterialHidden: "This material is set to hidden.",
    isMaterialInactive: "This material is set to inactive.",
    noMaterialSelected: "No material selected",
    localMaterialPrompt1: "Change material only for this part.",
    localMaterialPrompt2: "The view might not show actual values due to multiple instances being selected. Disable the multiple editing mode to see the data for a single instance.",
    globalMaterialPrompt: "Change the material wherever this part is used",
    multiInstanceEditingMode: "Multi Instance Editing Mode",
    rotLocScaleSetterDescription: "This is saving to the instance only (which means: not all screws, but only this one)",
    MATERIAL: "Material",
    TILING: "Tiling",
    COLOR: "Color",
}
